import React from 'react'
import { LoadingState } from './LoadingState'
import { ErrorState } from './ErrorState'

interface QueryStatusProps {
  loading?: boolean
  error?: boolean | Error | string | null
  empty?: boolean
  onRetry?: () => void
  loadingMessage?: string
  errorTitle?: string
  errorMessage?: string
  emptyContent?: React.ReactNode
  fullScreen?: boolean
  children: React.ReactNode
}

/**
 * Composes LoadingState / ErrorState / empty slot / children for async surfaces.
 */
export function QueryStatus({
  loading = false,
  error = null,
  empty = false,
  onRetry,
  loadingMessage = 'Loading...',
  errorTitle = 'Something went wrong',
  errorMessage = 'We encountered an error while loading this content. Please try again.',
  emptyContent,
  fullScreen = false,
  children,
}: QueryStatusProps) {
  if (loading) {
    return <LoadingState message={loadingMessage} fullScreen={fullScreen} />
  }

  const hasError = Boolean(error)
  if (hasError) {
    const message =
      typeof error === 'string'
        ? error
        : error instanceof Error
          ? error.message
          : errorMessage
    return (
      <ErrorState
        title={errorTitle}
        message={message || errorMessage}
        onRetry={onRetry}
        fullScreen={fullScreen}
      />
    )
  }

  if (empty && emptyContent) {
    return <>{emptyContent}</>
  }

  return <>{children}</>
}

export default QueryStatus
